exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".controls--1l5XF {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: end;\n      justify-content: flex-end;\n  padding: 10px;\n}\n", ""]);

// exports
exports.locals = {
	"controls": "controls--1l5XF"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":false,"sourceMap":false,"localIdentName":"[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false,"plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js?{"data":"$env: production;","sourceMap":false,"outputStyle":"expanded","precision":10,"includePaths":["/app/node_modules","/app/src"]}!./src/containers/Private/pages/workflow-admin/Users/Users.m.scss
// module id = 1596
// module chunks = 0